module.exports = __webpack_public_path__ + "static/media/s4.1f2a0fe5.png";